/* eslint no-console:0 */

import "@hotwired/turbo-rails"
require("@rails/activestorage").start()
require("local-time").start()

import "./channels"
import "./controllers"
import "./src/**/*"
import "chartkick/chart.js"
import { Chart } from "chart.js"
import Annotation from "chartjs-plugin-annotation"
import Datalabel from "chartjs-plugin-datalabels"
Chart.register(Annotation)
Chart.register(Datalabel)

// Set global Chart.js defaults for white text on dark backgrounds
Chart.defaults.color = "#FFFFFF"
Chart.defaults.scale.ticks.color = "#FFFFFF"
Chart.defaults.plugins.legend.labels.color = "#FFFFFF"
